import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestForm', {
    createRequestPageTitle: 'Create a {workflowName}',
    editRequestPageTitle: 'Edit a {workflowName}',
});
